import Config from 'Config';
import { getCurrentCompanyId, signoutWhenExpiredToken } from '../../Lib/Utils';
import * as ActionTypes from '../actionTypes';
import { getWithoutOverride, postWithoutOverride } from '../api';

export function resetState() {
    return (dispatch) => {
        dispatch({
            type: ActionTypes.RESET_PAYMENT_DATA_STORE,
        });
    };
}

export function getListV2({ nextPage, status } = {}) {
    return async (dispatch) => {
        dispatch({
            type: ActionTypes.STARTING_GET_PAYMENT_LIST,
        });
        try {
            let queryString = '';
            if (nextPage) queryString = `?${nextPage}`;
            else if (status) queryString = `?filter[status]=${status}`;
            const res = await getWithoutOverride(`${Config.payments2_api}/raw${queryString}`, {}, null, true);
            const { payments, nextPage: responseNextPage } = res.data;
            dispatch({
                type: ActionTypes.COMPLETE_GET_PAYMENT_LIST,
                payload: { payments: payments || [], nextPage: responseNextPage, paginated: Boolean(nextPage) },
            });
            return payments;
        } catch (error) {
            await signoutWhenExpiredToken();
            dispatch({
                type: ActionTypes.FAILED_GET_PAYMENT_LIST,
            });
            return error;
        }
    };
}

/**
 *
 * @param {{data: string; fileName: string; type: string;}} params
 *
 *  @returns {Promise<{success: false, data?:never} | undefined | {data?: {data?: {id?: string}}}>} // based on
 *  [CreateExpenseSlider.tsx](https://bitbucket.org/Paytron/paytron/src/441e47b69df01de7f12fe165146b041a998c9140/ptrn-fe/src/Components/Expenses/CreateExpenseSlider/CreateExpenseSlider.tsx#lines-181)
 *  implementation, complicated by redux-thunk intercepting the actually returned function and just returning the
 *  returned functions return value.
 */
export function createInvoice(params) {
    return async () => {
        return new Promise(async (resolve) => {
            try {
                const res = await postWithoutOverride(`${Config.bills_api_v1}/attachments`, params, null, true);
                return resolve(res);
            } catch (err) {
                console.log('Error', err);
                return resolve({ success: false });
            }
        });
    };
}

const xeroAccountCache = { expiresAt: new Date(), savedCompanyId: '' };
export function getXeroAccounts() {
    console.debug({ xeroAccountCache });
    return async () => {
        const companyId = getCurrentCompanyId();

        if (xeroAccountCache.expiresAt >= new Date() && xeroAccountCache.savedCompanyId === companyId) {
            return xeroAccountCache.data;
        }

        const res = await getWithoutOverride(`${Config.api}/xero/accounts`, undefined, undefined, true);

        xeroAccountCache.savedCompanyId = companyId;
        xeroAccountCache.data = res.data;
        xeroAccountCache.expiresAt = new Date();
        xeroAccountCache.expiresAt.setMinutes(new Date().getMinutes() + 60);

        return xeroAccountCache.data;
    };
}

const xeroTaxRateCache = { expiresAt: new Date() };
export function getXeroTaxRates() {
    console.debug({ xeroTaxRateCache });
    return async () => {
        if (xeroTaxRateCache.expiresAt >= new Date()) {
            return xeroTaxRateCache.data;
        }
        const companyId = getCurrentCompanyId();

        const res = await getWithoutOverride(`${Config.api}/xero/tax-rates`, undefined, undefined, true);
        xeroTaxRateCache.data = res.data;
        xeroTaxRateCache.expiresAt = new Date();
        xeroTaxRateCache.expiresAt.setMinutes(new Date().getMinutes() + 60);

        return xeroTaxRateCache.data;
    };
}
